module.exports = __webpack_public_path__ + "media/images/icon-national-area-9b8991a28e5291a12bf27f2109f1480a.svg";